import { EditFieldBase } from './edit-field-base.model';
import { EditFieldDropdown } from './edit-field-dropdown.model';
import { EditFieldMetadataTypeEnum } from './edit-field-metadata-type.enum.model';
import { EditFieldNumeric } from './edit-field-numeric.model';
import { EditFieldTextbox } from './edit-field-textbox.model';
import { EditFieldsEnum } from './edit-field.model';

export const invoiceEditFields: EditFieldBase<any>[] = [
    new EditFieldTextbox({
        key: EditFieldsEnum.InvoiceNumber,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.invoice_number',
        required: true,
        order: 1
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaseOrderNumber,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchase_order_number',
        required: true,
        order: 2
    }),
    new EditFieldNumeric({
        key: EditFieldsEnum.InvoiceValue,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.invoice_value',
        required: true,
        order: 3
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.CurrencyCode,
        i18nText: 'concepts.declarations.massAdjustments.level.good.currency_code',
        metadataType: EditFieldMetadataTypeEnum.CurrencyCode,
        required: true,
        order: 4
    }),
    new EditFieldDropdown({
        key: EditFieldsEnum.USPortOfExit,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.us_port_exit',
        metadataType: EditFieldMetadataTypeEnum.USPortOfExit,
        required: true,
        order: 5
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaserName,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchaser_name',
        required: true,
        order: 6
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaserPOBox,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchaser_po_box',
        required: true,
        order: 7
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaserAddressLine1,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchaser_address_line_1',
        required: true,
        order: 8
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaserAddressLine2,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchaser_address_line_2',
        required: true,
        order: 9
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaserCity,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchaser_city',
        required: true,
        order: 10
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaserCountry,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchaser_country',
        required: true,
        order: 11
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaserProvince,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchaser_province',
        required: true,
        order: 12
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaserPostalCode,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchaser_postal_code',
        required: true,
        order: 13
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.PurchaserTelephone,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.purchaser_telephone',
        required: true,
        order: 14
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.VendorName,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.vendor_name',
        required: true,
        order: 15
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.VendorPOBox,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.vendor_po_box',
        required: true,
        order: 16
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.VendorAddressLine1,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.vendor_address_line_1',
        required: true,
        order: 17
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.VendorAddressLine2,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.vendor_address_line_2',
        required: true,
        order: 18
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.VendorCity,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.vendor_city',
        required: true,
        order: 19
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.VendorCountry,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.vendor_country',
        required: true,
        order: 20
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.VendorProvince,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.vendor_province',
        required: true,
        order: 21
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.VendorPostalCode,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.vendor_postal_code',
        required: true,
        order: 22
    }),
    new EditFieldTextbox({
        key: EditFieldsEnum.VendorTelephone,
        i18nText: 'concepts.declarations.massAdjustments.level.invoice.vendor_telephone',
        required: true,
        order: 23
    }),
];
